import Intro from "../../../../src/components/ratelimit-p1/intro";
import Algorithms from "../../../../src/components/ratelimit-p1/algorithms";
import Resources from "../../../../src/components/ratelimit-p1/resources";
import * as React from 'react';
export default {
  Intro,
  Algorithms,
  Resources,
  React
};